/* eslint-disable react-hooks/rules-of-hooks */
import styled from '@emotion/styled'
import { ButtonBase, ButtonProps as MuiButtonProps } from '@mui/material'
import { alphaColorPallete } from 'src/components/button/palettes'
import { Colors, Shadows, Shapes, Typographies, useTypography } from 'src/components/theme'

type ButtonProps = MuiButtonProps & {
  elevation?: boolean
}

export const ButtonOutlined = (props: ButtonProps) => {
  const { startIcon, children, ...rest } = props
  return (
    <BtnOutlined {...rest}>
      {startIcon && <span className="start-icon">{startIcon as React.ReactNode}</span>}
      {children}
    </BtnOutlined>
  )
}

const BtnOutlined = styled(ButtonBase)<ButtonProps>`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
  padding: ${Shapes.spacing[2]}px ${Shapes.spacing[5]}px;
  background-color: ${Colors.bgWhite};
  border-radius: ${Shapes.borderRadius}px;
  border: 1px solid ${(props) => alphaColorPallete[props.color ?? 'inherit'].dark};
  color: ${(props) => alphaColorPallete[props.color ?? 'inherit'].dark};
  ${useTypography(Typographies.title2l)}
  box-shadow: ${(props) => (props.elevation ? Shadows.shadowLight : 'none')};
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${Colors.bgLight};
    box-shadow: ${(props) => (props.elevation ? Shadows.shadowMedium : 'none')};
  }
  &:active {
    background-color: ${Colors.bgLight};
    box-shadow: ${(props) => (props.elevation ? Shadows.shadowDark : 'none')};
  }

  &:disabled {
    opacity: 0.4;
    box-shadow: none;
    cursor: not-allowed;
    pointer-events: none;
  }

  & > span.start-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    height: 18px;
    width: 18px;
    padding: 4px;
    border-radius: 50%;
    svg {
      color: ${(props) => alphaColorPallete[props.color ?? 'inherit'].dark};
    }
  }
`
